import { getSlugFromUrl } from './product-schema';
import { COMPETITORS } from './comparison-data';

const BREADCRUMB_PAGES = {
  'damage-detection': 'Damage Detection',
  'claim-estimation': 'Claim Assessment',
  'fraud-detection': 'Fraud Detection',
  'photo-video-capture': 'Photo & Video Capture',
  'photo-quality': 'Photo Quality API',
  'vehicle-damage-scanners': 'Vehicle Damage Scanners',
  'ai-powered-ocr': 'AI-powered OCR',
  'insurance': 'Insurance',
  'automotive': 'Automotive',
  'car-rental': 'Car Rental/Leasing',
  'vehicle-remarketing': 'Vehicle Remarketing',
  'fleet-inspection-software': 'Fleet Inspection Software',
  'truck-inspection-software': 'Truck Inspection Software',
  'motorcycle-inspection-software': 'Motorcycle Inspection Software',
  'compare': 'Comparison Hub',
  'workflow': 'Workflow',
  'our-core-technology': 'Our Core Technology',
};

export function getBreadcrumbSchema({ url }) {
  const slug = getSlugFromUrl(url);

  if (!slug) return null;

  // Comparison sub-pages: /compare/inspektlabs-vs-<competitor>
  if (slug.startsWith('compare/')) {
    const subSlug = slug.slice('compare/'.length);
    const competitor = Object.values(COMPETITORS).find((c) => c.slug === subSlug);
    if (!competitor) return null;

    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://inspektlabs.com/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Comparison Hub',
          item: 'https://inspektlabs.com/compare',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: `Inspektlabs vs ${competitor.name}`,
          item: url,
        },
      ],
    };
  }

  if (!(slug in BREADCRUMB_PAGES)) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://inspektlabs.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: BREADCRUMB_PAGES[slug],
        item: url,
      },
    ],
  };
}
